import React, { Component, createRef } from 'react';
import * as moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import FilterButton from '../../Common/FilterButtons';
import 'bootstrap-daterangepicker/daterangepicker.css';
import qs from 'query-string';
import { withRouter } from 'react-router-dom';
import ViewFilter from './ViewFilter';
import { hot } from 'react-hot-loader';

const TRANSACTION_SEQUENCE_TAB = 3;
class Filter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_name: '',
			_transactionId: '',
			_email: '',
			_fromDate: null,
			_toDate: null
		};
	}

	dateRef = createRef();

	handleDateEvent = (_event, picker) => {
		this.setState({
			_fromDate: picker.startDate.format('YYYY-MM-DD'),
			_toDate: picker.endDate.format('YYYY-MM-DD')
		});
	};

	resetFilter = () => {
		const queryItem = qs.parse(window.location.search);
		queryItem.name = '';
		queryItem.transactionId = '';
		queryItem.email = '';
		queryItem.fromDate = '';
		queryItem.toDate = '';
		this.props.history.push({
			search: qs.stringify(queryItem)
		});

		this.setState({
			_name: '',
			_transactionId: '',
			_email: '',
			_fromDate: null,
			_toDate: null
		});
		this.dateRef.current.setStartDate(moment().toDate());
		this.dateRef.current.setEndDate(moment().toDate());
		this.props.onResetFilter();
	};

	handleSearch = () => {
		const { _name, _transactionId, _email, _fromDate, _toDate } = this.state;
		const queryItem = qs.parse(window.location.search);
		queryItem.email = _email;
		queryItem.name = _name;
		queryItem.transactionId = _transactionId;
		if (_fromDate) {
			queryItem.fromDate = _fromDate;
		}
		if (_toDate) {
			queryItem.toDate = _toDate;
		}
		if (Number(queryItem.tab) === TRANSACTION_SEQUENCE_TAB) {
			this.props.history.push({
				search: qs.stringify(queryItem)
			});
		}
		this.props.onSearch({
			name: _name.trim(),
			transactionId: _transactionId.trim(),
			email: _email.trim(),
			fromDate: _fromDate,
			toDate: _toDate
		});
	};

	setDefaultFilter = async () => {
		const queryItem = qs.parse(window.location.search);
		const fromDate = !queryItem.fromDate
			? moment().format('YYYY-MM-DD')
			: moment(queryItem.fromDate).format('YYYY-MM-DD');
		const toDate = !queryItem.toDate
			? moment().format('YYYY-MM-DD')
			: moment(queryItem.toDate).format('YYYY-MM-DD');
		if (this.dateRef.current) {
			this.dateRef.current.setStartDate(moment(fromDate).toDate());
			this.dateRef.current.setEndDate(moment(toDate).toDate());
		}
		await this.setState({
			_name: queryItem.name || '',
			_transactionId: queryItem.transactionId || '',
			_email: queryItem.email || '',
			_fromDate: queryItem.fromDate ? fromDate : null,
			_toDate: queryItem.toDate ? toDate : null
		});
		this.handleSearch();
	};

	componentDidMount() {
		this.setDefaultFilter();
	}

	componentDidUpdate(nextProps) {
		if (nextProps.location.search !== this.props.location.search) {
			this.setDefaultFilter();
		}
	}

	render() {
		return (
			<div className="row filter_header" style={{ marginBottom: '30px', marginTop: '20px' }}>
				{this.props.match.path === '/admin/transactions' ? (
					<ViewFilter
						setType={this.props.setType}
						handleDateEvent={this.handleDateEvent}
						resetFilter={this.resetFilter}
						dateRef={this.dateRef}
						fromDate={this.state._fromDate}
						toDate={this.state._toDate}
						onSearch={this.props.onSearch}
						onResetFilter={this.props.onResetFilter}
					/>
				) : (
					<>
						<div className="col-2">
							<input
								className="form-control"
								onChange={e => {
									this.setState({ _name: e.target.value });
								}}
								placeholder="Name"
								type="text"
								value={this.state._name}
							/>
						</div>
						<div className="col-2">
							<input
								className="form-control"
								onChange={e => {
									this.setState({ _transactionId: e.target.value });
								}}
								placeholder="Transaction ID"
								type="text"
								value={this.state._transactionId}
							/>
						</div>
						<div className="col-2">
							<input
								className="form-control"
								onChange={e => {
									this.setState({ _email: e.target.value });
								}}
								placeholder="Email"
								type="text"
								value={this.state._email}
							/>
						</div>
						<div className="col-2">
							<DateRangePicker onEvent={this.handleDateEvent} ref={this.dateRef}>
								<input className="form-control" type="text" />
							</DateRangePicker>
						</div>
						<FilterButton handleSearch={this.handleSearch} resetFilter={this.resetFilter} />
					</>
				)}
			</div>
		);
	}
}

export default withRouter(hot(module)(Filter));
